import type { SVGProps } from 'react'
const SvgQueueEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.6665 13.8346H2.71775L11.2482 5.30422L10.1969 4.25297L1.6665 12.7834V13.8346ZM0.416504 15.0846V12.2642L11.4086 1.27693C11.5346 1.16248 11.6737 1.07408 11.8259 1.01172C11.9782 0.949219 12.138 0.917969 12.305 0.917969C12.4721 0.917969 12.6339 0.947622 12.7905 1.00693C12.9471 1.06623 13.0858 1.16054 13.2065 1.28984L14.2242 2.32026C14.3535 2.44095 14.4457 2.57984 14.5007 2.73693C14.5557 2.89401 14.5832 3.05109 14.5832 3.20818C14.5832 3.37582 14.5546 3.53575 14.4973 3.68797C14.4401 3.84033 14.3491 3.9795 14.2242 4.10547L3.23692 15.0846H0.416504ZM10.7134 4.78776L10.1969 4.25297L11.2482 5.30422L10.7134 4.78776Z"
      fill="#5E5E5E"
    />
  </svg>
)

export default SvgQueueEdit
